export default "__VITE_ASSET__0e4c68df__"